import shave from 'shave';
import PageLoadedQueue from "./PageLoadedQueue";

const shaveLines = () => {
    const elements = document.querySelectorAll('.shave-text');

    elements.forEach((element) => {
        shave(element, element.clientHeight);
    });
}

window.addEventListener('resize', () => {
    shaveLines();
});

PageLoadedQueue.addFunction(shaveLines);
